import React from 'react';
import styled from 'styled-components';
const CloseBlueIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/xIcon.svg';

export type TagAlertProps = {
  info: string;
  closeButton?: boolean;
  onClickClose?: () => void;
};

const Container = styled.div`
  background: #c93431;
  border-left: 6px solid #ef4f4c;
  display: flex;
  flex-direction: row;
  padding: 16px;
  align-items: center;

  & .info {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    margin-right: 16px;
  }

  & .close-button {
    margin-left: auto;
    width: 24px;
    height: 24px;
  }
`;

const TagAlert: React.FC<TagAlertProps> = ({ info, closeButton, onClickClose }) => {
  return (
    <Container>
      <p className="info">{info}</p>
      {closeButton && <img onClick={onClickClose} className="close-button" src={CloseBlueIcon} alt="tagalert-fechar" />}
    </Container>
  );
};

export default TagAlert;
